import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import GoalForm from "../components/GoalForm";
import GoalItem from "../components/GoalItem";
import Spinner from "../components/Spinner";
import { getGoals, reset } from "../features/goals/goalSlice";
import { FaClipboardList } from "react-icons/fa";
import axios from "axios";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Header,
  PageBreak,
  Table,
  TableCell,
  TableRow,
  WidthType,
} from "docx";
import { saveAs } from "file-saver";
import { logout } from "../features/auth/authSlice";
import converter from "number-to-words";

function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPending, setShowPending] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [purchaseContracts, setPurchaseContracts] = useState([]);

  const [showPurchaseContracts, setShowPurchaseContracts] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const [formState, setFormState] = useState({
    releaseName: "",
    numberOfSongs: 1,
    futureSongsIncluded: false,
    futureSongsNumber: 1,
    // futures: [],
    futureOptionNumber: 1,
    futureOptionNumberInWords: "one",
    futureOptionPeriod: "year",
    futureAdvanceValue: "1000",
    futureAdvanceValueInWords: "one thousand",
    futureMarketingValue: "3000",
    futureMarketingValueInWords: "three thousand",
    publishingIncluded: false,
    numberOfArtists: 1,
    songs: [{ name: "" }],
    artists: [
      {
        stageName: "",
        legalName: "",
        address: "",
        dob: new Date(),
        publisher: "N/A", // Default to 'N/A'
        ipiNumber: "N/A",
        publisherName: "N/A",
        parentGuardianName: "",
      },
    ],
    advanceIncluded: false,
    marketingIncluded: false,
    agreementDate: new Date(),
    netProceeds: {
      percentage: 55,
      percentageInWords: "Fifty-five",
    },
    termLength: {
      lifeOfCopyright: false,
      numberOfYears: 2,
      numberOfYearsInWords: "Two",
    },
    advanceAmount: {
      value: "1000",
      valueInWords: "One thousand",
    },
    marketingBudget: {
      value: "3000",
      valueInWords: "Three thousand",
    },
    //actual text
    titleText: "",
    dateText: "",
    artistsText: "",
    artistsInPreambleText: "",
  });

  const [purchaseFormState, setPurchaseFormState] = useState({
    releaseName: "",
    numberOfSongs: 1,
    purchasePrice: 1000,
    // futureSongsIncluded: false,
    // futureSongsNumber: 1,
    // // futures: [],
    // futureOptionNumber: 1,
    // futureOptionNumberInWords: "one",
    // futureOptionPeriod: "year",
    // futureAdvanceValue: 1000,
    // futureAdvanceValueInWords: "one thousand",
    // futureMarketingValue: 3000,
    // futureMarketingValueInWords: "three thousand",
    // publishingIncluded: false,
    numberOfArtists: 1,
    songs: [{ name: "" }],
    artists: [
      {
        stageName: "",
        legalName: "",
        address: "",
        dob: new Date(),
        // publisher: "N/A", // Default to 'N/A'
        // ipiNumber: "N/A",
        // publisherName: "N/A",
        parentGuardianName: "",
      },
    ],
    // advanceIncluded: false,
    // marketingIncluded: false,
    agreementDate: new Date(),
    // netProceeds: {
    //   percentage: 55,
    //   percentageInWords: "Fifty-five",
    // },
    // termLength: {
    //   lifeOfCopyright: false,
    //   numberOfYears: 2,
    //   numberOfYearsInWords: "Two",
    // },
    // advanceAmount: {
    //   value: 1000,
    //   valueInWords: "One thousand",
    // },
    // marketingBudget: {
    //   value: 3000,
    //   valueInWords: "Three thousand",
    // },
    //actual text

    // titleText: "",
    // dateText: "",
    // artistsText: "",
    // artistsInPreambleText: "",
  });

  const { user } = useSelector((state) => state.auth);
  const { goals, isLoading, isError, message } = useSelector(
    (state) => state.goals
  );
  //const pendingAlbums = goals.filter(
  //  (album) => album.status === "pending approval by team"
  //);

  useEffect(() => {
    // Ensure formState is not null or undefined
    if (formState && formState.releaseName != "") {
      // Download
      handleSubmit();
    }
    // Add more dependencies if needed, but beware of creating an infinite loop
  }, [formState]);

  useEffect(() => {
    // Ensure formState is not null or undefined
    if (purchaseFormState && purchaseFormState.songs[0].name != "") {
      // Download
      createPurchaseDocx();
    }
    // Add more dependencies if needed, but beware of creating an infinite loop
  }, [purchaseFormState]);

  useEffect(() => {
    if (isError) {
      console.log(message);
      //localStorage.clear();
    }

    if (!user) {
      /*setTimeout(() => {
        console.log("World!");
      }, 5000);*/
      navigate("/login");
      console.log("yeetDash");
    }

    async function getContractData() {
      try {
        const response = await axios.get("/api/contracts", {
          headers: {
            // Include other headers as needed, for example, an authorization header:
            Authorization: `Bearer ${user.token}`,
          },
        });
        console.log(response);
        setContracts(response.data);
      } catch (error) {
        console.error(error);
        // log out
        dispatch(logout());
        navigate("/login");
      }
    }

    async function getPurchaseContractData() {
      try {
        const response = await axios.get("/api/purchasecontracts", {
          headers: {
            // Include other headers as needed, for example, an authorization header:
            Authorization: `Bearer ${user.token}`,
          },
        });
        console.log(response);
        setPurchaseContracts(response.data);
      } catch (error) {
        console.error(error);
        // log out
        dispatch(logout());
        navigate("/login");
      }
    }

    if (user && (user.role == "admin" || user.role == "user")) {
      //dispatch(getGoals());
      getContractData();
      getPurchaseContractData();
    }

    return () => {
      dispatch(reset());
    };
  }, [user]);

  useEffect(() => {
    // if 2FA is false in local storage, then log out
    if (localStorage.getItem("2FA") === "false") {
      dispatch(logout());
      navigate("/login");
    }
  }, []);

  const createPurchaseDocx = async () => {
    let scheduleC = [];

    for (let i = 0; i < purchaseFormState.artists.length; i++) {
      if (
        new Date() <
        new Date(
          purchaseFormState.artists[i].dob.getFullYear() + 18,
          purchaseFormState.artists[i].dob.getMonth(),
          purchaseFormState.artists[i].dob.getDate()
        )
      ) {
        scheduleC.push(
          new Paragraph({
            children: [
              new TextRun({
                text: ``,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
            ],
            alignment: "center",
            pageBreakBefore: true,
          })
        );

        scheduleC.push(
          new Paragraph({
            children: [
              new TextRun({
                text: `The undersigned, legal guardian(s) of `,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: `${purchaseFormState.artists[i].legalName} p/k/a: “${purchaseFormState.artists[i].stageName}”`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: ` (“Seller”), has read the foregoing agreement and as an inducement for `,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: `The System Music LLC`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: ` (“Buyer”) to enter into the foregoing agreement, warrants and represents to Buyer that: (a) Seller will fully perform all of Seller’s obligations pursuant to the foregoing agreement; (b) the undersigned consents to the execution and performance of the foregoing agreement; (c) until the foregoing agreement has been ratified by Seller after reaching the age of majority, the undersigned shall indemnify and hold Buyer harmless from and against any and all reasonable costs, expenses, losses, liabilities and damages (including, without limitation, reasonable court costs, counsel fees and disbursements) arising out of the failure of Seller to comply with the terms of the Agreement.`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: `AGREED, ACCEPTED, & ACKNOWLEDGED:`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
              new TextRun({
                text: `____________________`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
              new TextRun({
                text: `${purchaseFormState.artists[i].parentGuardianName}`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 1,
              }),
              new TextRun({
                text: `I am the legal guardian of ${purchaseFormState.artists[i].legalName} p/k/a: “${purchaseFormState.artists[i].stageName}”`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
            ],
          })
        );
      }
    }

    const doc = new Document({
      sections: [
        {
          // headers: {
          //   default: header,
          // },
          children: [
            // Adding one new lines (blank paragraphs)
            // new Paragraph(""),
            // The next paragraph with 'Hello, World!' text
            new Paragraph({
              children: [
                new TextRun({
                  text: `Purchase Agreement`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
              alignment: "center",
            }),
            // Add more content as needed
            // new Paragraph(""),
            new Paragraph(""),

            new Paragraph({
              children: [
                new TextRun({
                  text: `DATE: ${purchaseFormState.agreementDate.toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }
                  )}`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            // ...topArtists,
            new Paragraph(""),

            // new Paragraph({
            //   children: [
            //     new TextRun({
            //       text: `&`,
            //       bold: false,
            //       size: 22, // Size in half-point, so 22 half-points = 12 points
            //       font: {
            //         name: "Helvetica Neue",
            //       },
            //     }),
            //   ],
            // }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Parties: `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `     1)  The System Music LLC (“Buyer”)`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `          3500 S DuPont Highway, Dover, DE 19901, and `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
                // new TextRun({
                //   text: `3500 S DuPont Highway, Dover, DE 19901`,
                //   bold: false,
                //   size: 22, // Size in half-point, so 22 half-points = 12 points
                //   font: {
                //     name: "Helvetica Neue",
                //   },
                //   break: 1,
                // }),
              ],
            }),
            // new Paragraph(""),
            // map each artist in the purchaseFormState.artists to a paragraph not in bold with the artists legalName
            ...purchaseFormState.artists.map(
              (artist, index) =>
                new Paragraph({
                  children: [
                    new TextRun({
                      text: `${index == 0 ? "     2)  " : "         "} ${
                        artist.legalName
                      } p/k/a ${artist.stageName} ("Seller")`,
                      bold: false,
                      size: 22, // 12 points in half-point
                      font: {
                        name: "Helvetica Neue",
                      },
                      break: 1,
                    }),
                    new TextRun({
                      text: `          ${artist.address}`,
                      bold: false,
                      size: 22, // 12 points in half-point
                      font: {
                        name: "Helvetica Neue",
                      },
                      break: 1,
                    }),
                  ],
                })
            ),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Agreement: `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `The parties agree as follows: `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `1.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `          1.1 Title: `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `${purchaseFormState.songs
                    .map(
                      (song) => `${song.name} (the “Master” and ”Composition”)`
                    )
                    .join(", ")}`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `          1.2 Performers/Writers: `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `${purchaseFormState.artists
                    .map((artist) => `${artist.legalName}`)
                    .join(", ")}`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `          1.3 Purchase Price: `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `${converter.toWords(
                    purchaseFormState.purchasePrice
                  )} United States Dollars ($${
                    purchaseFormState.purchasePrice
                  })`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `2.        In consideration of the payment by the Buyer to the Seller of the Purchase Price the Seller hereby sells to the Buyer all rights of whatever nature including copyrights and any extensions and renewals thereof in the Master and Composition. Seller agrees that upon receipt by him of the Purchase Price he shall have no right to any further payment of whatever nature from any party (including, without limitation, Buyer) in connection with the exploitation of the Master and/or Composition (including, without limitation, any so-called “writer’s share” of income derived from the Composition). Buyer may use (but has no obligation to use) the Master and Composition in whole or in part in any form in any manner or media whether now or hereafter known. Buyer shall be free to alter the Master and/or Composition as it sees fit.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.        Seller warrants and represents:`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.1       Seller is the sole author of the Master and Composition, and/or the Seller controls all rights, title and interest of whatever nature in the Master and Composition and has not disposed of the same to any party or given any party rights to exploit the same in any manner.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.2       Each Person who rendered any service in connection with, or who otherwise contributed in any way to the making of the Master and/or Composition, or who granted to Seller Seller’s rights referred to in this Agreement, had the full right, power and authority to do so, and was not bound by any agreement which would restrict such person from rendering such services or granting such rights.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.3       All recording costs and expenses with respect to the making of the Master and Composition have been paid.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.4       All necessary licenses for the recording of the Compositions performed in the Master have been obtained from the copyright owners, and all monies payable under such licenses or otherwise by reason of such recording have been paid. `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.5       Buyer and parties deriving rights from Buyer shall have the sole and exclusive rights throughout the universe to manufacture, advertise, distribute, sell and otherwise exploit and deal in the Master, Composition and Phonograph Records and other reproductions derived from them, free from any liability or obligation to make any payments for them.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.6       There are no samples (master and/or composition) in the Master and/or Composition.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Signed as an agreement by the parties the day and date written above.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `THE SYSTEM MUSIC, LLC`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `By: _________________________________`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `       An authorized signatory`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            // map each artist in the purchaseFormState.artists to a paragraph with a line and then the artist's legalName p/k/a stageName like below
            ...purchaseFormState.artists.map(
              (artist) =>
                new Paragraph({
                  children: [
                    new TextRun({
                      text: `_______________________________`,
                      bold: false,
                      size: 22, // 12 points in half-point
                      font: {
                        name: "Helvetica Neue",
                      },
                      break: 3,
                    }),
                    new TextRun({
                      text: `       ${artist.legalName} p/k/a ${artist.stageName}`,
                      bold: false,
                      size: 22, // 12 points in half-point
                      font: {
                        name: "Helvetica Neue",
                      },
                      break: 1,
                    }),
                  ],
                })
            ),
            ...scheduleC,

            // new Paragraph(""),
            // new Paragraph(""),
            // new Paragraph(""),
            // new Paragraph({
            //   children: [
            //     new TextRun({
            //       text: `    _________________________________`,
            //       bold: false,
            //       size: 22, // Size in half-point, so 22 half-points = 12 points
            //       font: {
            //         name: "Helvetica Neue",
            //       },
            //     }),
            //     new TextRun({
            //       text: `    ${purchaseFormState.artists[0].legalName} p/k/a ${purchaseFormState.artists[0].stageName}`,
            //       bold: false,
            //       size: 22, // Size in half-point, so 22 half-points = 12 points
            //       font: {
            //         name: "Helvetica Neue",
            //       },
            //       break: 1,
            //     }),
            //   ],
            // }),
          ],
        },
      ],
    });

    // doc.addSection({ children: [masterTable] });

    // Use Packer to create a Blob
    const blob = await Packer.toBlob(doc);

    let fileName = "";
    // for (let i = 0; i < purchaseFormState.artists.length; i++) {
    //   fileName += purchaseFormState.artists[i].stageName.replace(/\./g, "") + " ";

    //   if (i != purchaseFormState.artists.length - 1) {
    //     fileName += "& ";
    //   }
    // }

    fileName += `${purchaseFormState.songs[0].name.replace(
      /\./g,
      ""
    )} The System Purchase Agreement.docx`;

    // saveAs from FileSaver will download the file
    saveAs(blob, fileName);

    return blob;
  };

  const createDocxBlob = async () => {
    // Define the header content
    const header = new Header({
      children: [
        new Paragraph({
          children: [
            new TextRun({
              text: "The System LICENSING AGREEMENT",
              bold: true,
              size: 22, // 12 points
              color: "000000",
              shading: {
                // Ensure this is either not set or correctly configured
                fill: "FFFFFF", // Setting to white or the desired background color
                color: "auto",
                val: "clear",
              },
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
          alignment: "center",
        }),
      ],
    });

    const topArtists = formState.artists.map(
      (artist) =>
        new Paragraph({
          children: [
            new TextRun({
              text: `The “ARTIST”: ${artist.legalName} p/k/a: “${artist.stageName}”`,
              bold: true,
              size: 22, // 12 points in half-point
              font: {
                name: "Helvetica Neue",
              },
              break: 1,
            }),
            new TextRun({
              text: `${artist.address}`,
              bold: false,
              size: 22, // 12 points in half-point
              font: {
                name: "Helvetica Neue",
              },
              break: 1,
            }),
          ],
        })
    );

    let artistsPreamble = [];
    formState.artists.forEach((artist, index) => {
      artistsPreamble.push(
        new TextRun({
          text: `${artist.legalName} p/k/a: “${artist.stageName}”`,
          bold: true, // Example styling
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );

      // Add an "&" except after the last item
      if (index < formState.artists.length - 1) {
        artistsPreamble.push(
          new TextRun({
            text: " & ",
            bold: true, // Match styling, adjust as needed
            size: 22, // 12 points in half-point
            font: {
              name: "Helvetica Neue",
            },
          })
        );
      }
    });

    let licensePeriod = [];
    if (formState.termLength.lifeOfCopyright) {
      licensePeriod.push(
        new TextRun({
          text: "2.1 “License Period” shall mean the period commencing on the date hereof and continuing for the entire life of the copyright in and to the Master and Composition, Including any and all extensions.",
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
    } else {
      licensePeriod.push(
        new TextRun({
          text: `2.1 “License Period” shall mean the period commencing on the date hereof and expiring on the later of: (i) ${formState.termLength.numberOfYearsInWords} (${formState.termLength.numberOfYears}) years after the date of the initial release of the last 	Master (as defined below) delivered hereunder; and (ii) the date on which all Expenses (as defined below) are recouped by Label (the “`,
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
      licensePeriod.push(
        new TextRun({
          text: "Initial License Period",
          bold: true, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
      licensePeriod.push(
        new TextRun({
          text: "”). The License Period shall automatically extend for additional consecutive five (5) year periods (each an “",
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
      licensePeriod.push(
        new TextRun({
          text: "Extension",
          bold: true, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
      licensePeriod.push(
        new TextRun({
          text: "”) thereafter unless either party delivers notice in writing not less than sixty (60) days prior to the expiry of the Initial License Period or the then current Extension (if applicable). ",
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
    }

    if (formState.futureSongsIncluded) {
      licensePeriod.push(
        new TextRun({
          text: `Additionally, Label may exercise the Label Option (as defined below) for the Additional Masters (as defined below) at any time prior to the ${formState.futureOptionNumberInWords} (${formState.futureOptionNumber}) ${formState.futureOptionPeriod} anniversary of date of the initial release of the last Master upon written notice to Artist. If Label does not give Artist notice of Label’s election to exercise the Label Option within the time limits set forth in this paragraph, Artist will give Label written notice of our failure to make such election and Label will have ten (10) business days after our receipt of such notice from Artist (the “Label Option Warning Period”) to exercise the Option. In no event will Labels’ right to exercise the Label Option terminate prior to the end of the Option Warning Period.`,
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
    }

    // Grant 3.1
    let grantOne = [];
    grantOne.push(
      new TextRun({
        text: "3.1 Artist hereby grants to Label an exclusive irrevocable license, in the Territory during the License period to (and the non-exclusive right during the Sell-Off Period) to manufacture, sell, distribute, market, publicly perform and otherwise exploit the Masters in all manner and media now in existence or hereinafter devised, including without limitation via digital transmissions, physical singles, albums, or audio-visual records",
        bold: false, // Match styling, adjust as needed
        size: 22, // 12 points in half-point
        font: {
          name: "Helvetica Neue",
        },
      })
    );

    if (formState.futureSongsIncluded) {
      grantOne.push(
        new TextRun({
          text: `, plus Label will have one (1) separate and successive irrevocable option for up to ${converter.toWords(
            formState.futureSongsNumber
          )} (${
            formState.futureSongsNumber
          }) additional master recordings (the “Additional Masters”)(the “Label Option”).  In the event that Label chooses to exercise the Label Option for the purposes of this Agreement the Additional Masters shall be deemed Masters hereunder. Furthermore, it should be noted that the Label retains the sole discretion to select which of the Additional Masters they wish to license and may refuse to license certain masters at their discretion, should the ("Additional Masters") option be invoked.`,
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
    } else {
      grantOne.push(
        new TextRun({
          text: `.`,
          bold: false, // Match styling, adjust as needed
          size: 22, // 12 points in half-point
          font: {
            name: "Helvetica Neue",
          },
        })
      );
    }

    let royaltiesSection = [];

    royaltiesSection.push(
      new Paragraph({
        children: [
          new TextRun({
            text: `4.1 With respect to the exploitation of Masters hereunder, Label will pay Artist a royalty (the “`,
            bold: false,
            size: 22, // 12 points in half-point
            font: {
              name: "Helvetica Neue",
            },
            break: 1,
          }),
          new TextRun({
            text: `Royalty`,
            bold: true,
            size: 22, // 12 points in half-point
            font: {
              name: "Helvetica Neue",
            },
          }),
          new TextRun({
            text: `”) equal to: (i) ${formState.netProceeds.percentageInWords} percent (${formState.netProceeds.percentage}%) of “Net Proceeds” (as defined below).  In the event that Artist wishes for Label to divide the Artist’s royalty among more than one person, Artist shall set out such division in Schedule “A”.    The Royalty shall be inclusive of all payments due to Artist in connection with any publishing royalties for Artist’s share of the Controlled Compositions as set out in section 6 below.`,
            bold: false,
            size: 22, // 12 points in half-point
            font: {
              name: "Helvetica Neue",
            },
          }),
        ],
      })
    );

    royaltiesSection.push(new Paragraph(""));

    royaltiesSection.push(
      new Paragraph({
        children: [
          new TextRun({
            text: `4.2 Other than as specifically set out in section 4.1 above, Artist shall have no entitlement to any other revenue derived from the Masters.`,
            bold: false,
            size: 22, // Size in half-point, so 22 half-points = 12 points
            font: {
              name: "Helvetica Neue",
            },
          }),
        ],
      })
    );

    royaltiesSection.push(new Paragraph(""));

    if (formState.advanceIncluded) {
      royaltiesSection.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `4.3 (a) Label shall pay Artist a recoupable “in pocket” advance (“Advance”) equal to ${formState.advanceAmount.valueInWords} United States Dollars ($${formState.advanceAmount.value}), which shall be payable promptly after execution of this Agreement. Further, in the event Label, at its sole discretion, pays any additional monies to Artist or any third party on behalf of Artist (provided that such payments are not classified as Expenses hereunder), then such additional monies shall be deemed part of the Advance. For the avoidance of doubt, the Advance shall be recoupable against the Royalty and Net Amounts (as defined below). `,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
    } else {
      royaltiesSection.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `4.3 (a) INTENTIONALLY DELETED`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
    }

    royaltiesSection.push(new Paragraph(""));

    if (formState.futureSongsIncluded) {
      royaltiesSection.push(
        new Paragraph({
          children: [
            new TextRun({
              text: ` (b) In the event that the Label chooses to exercise the Label Option, Label shall pay Artist an additional recoupable Advance in the amount of ${formState.futureAdvanceValueInWords} United States Dollars ($${formState.futureAdvanceValue}).`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      royaltiesSection.push(new Paragraph(""));
      royaltiesSection.push(
        new Paragraph({
          children: [
            new TextRun({
              text: ` (c) In the event that Label chooses to exercise the Label Option, Label shall commit to a recoupable marketing fund in the amount of ${formState.futureMarketingValueInWords} United States Dollars ($${formState.futureMarketingValue}).`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      royaltiesSection.push(new Paragraph(""));
    }

    if (formState.marketingIncluded) {
      royaltiesSection.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `4.4  Label shall commit to a marketing fund in the amount of ${formState.marketingBudget.valueInWords} United States Dollars ($${formState.marketingBudget.value}) (the “Marketing Fund”) to be administered by us on your behalf in connection with third party marketing and promotion expenses with respect to the Masters which have been pre-approved by us in writing (such approval not to be unreasonably withheld or delayed, but in the event of a disagreement, our sole good faith business discretion shall control).  Any amounts incurred or paid by us from the Marketing Fund shall be deemed fully-recoupable advances against all royalties, payments and other earnings otherwise payable to you under this Agreement.`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
    }

    let publishing = [];

    if (formState.publishingIncluded) {
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8. PUBLISHING`,
              bold: true,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      publishing.push(new Paragraph(""));
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8.1. For good and valuable  consideration  the  receipt  and  sufficiency of  which  is acknowledged by Artist, Artist hereby agrees to and hereby does sell, assign, transfer and deliver to Label, and its successors and assigns, an undivided one hundred percent (100%) interest in and to all of Writer’s interest in every musical composition that is embodied on a Master licensed by Label hereunder that Writer shall write, compose, create, acquire or otherwise control in whole or in part from prior to the date hereof and through the expiration of the License Period and any extension(s) hereof, whether created by Writer alone or in collaboration with others and inclusive of any and all third party interests in any third party musical works to the full extent acquired by Writer (the “Published Compositions” and each a “Published Composition”), for the entire Universe and for the life of copyright therein (the “Retention Period”).    For the avoidance of doubt, the rights granted by Writer hereunder shall include Writer's interest in the copyrights and/or the right to copyright the same as proprietor in Publisher’s  own  name,  or  otherwise,  as  Publisher  may  elect  in  all  countries throughout the world.  During the Retention Period, Writer hereby waives in favor of Publisher and Publisher’s successors, licensees and assigns, all of Writer's moral rights and droites de suite in all Published Compositions in each territory of the world to the full extent same may be waived.`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      publishing.push(new Paragraph(""));
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8.2. Label shall be the exclusive administrator of all rights in and to each Published Composition, and shall be entitled to exercise any and all rights with respect to the control, exploitation and administration of each Published Composition. Artist shall further, upon Label’s request, execute and deliver to Label, any assignments of copyright in and to the Published Compositions as Label may reasonably deem necessary, and Artist hereby appoints Label as Artist’s attorney-in-fact for the purpose of executing such assignments in Artist’s name. Without limiting the generality of the foregoing, with respect to each Published Composition transferred hereunder, Artist shall execute an assignment in the form set out in Schedule B attached hereto.`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      publishing.push(new Paragraph(""));
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8.3. Without limiting its rights, Label shall hereinafter have the sole and exclusive right in perpetuity and throughout the Territory: (a) to release, publish, distribute and commercially exploit the Published Compositions in any media whether now known or hereinafter devised; (b) to grant licenses for synchronization, recording, reproduction and use of the Published Compositions in and with motion picture, television films and commercial advertisements; (c) to register the copyright in and to the Published Compositions in Label’s name as owner and author thereof; (d) to grant the rights of public performance of the Published Composition, by any means whether now known or hereinafter devised, and to license such rights throughout the Territory, (e) to collect any and all royalties, fees and other monies earned with respect to the Published Compositions (other than the so-called “writer’s share” of any public performance royalties payable in respect of the Published Compositions; (f) to grant and or license to third parties any of the rights in and to the Published Compositions granted hereunder to Label; (g) to make any and all arrangements and adaptations of the Composition of any kind or nature, to produce any new lyric thereof or translation of the original lyrics thereof, to change the title thereof and to do every other act and thing necessary to make the Published Compositions suitable and proper for publication throughout the Territory (and to publish, use and exploit the Published Compositions with or without any such arrangement, adaptation, new lyric or translation thereof throughout the Territory); (h) to assign, grant, transfer and or license to third parties any of the rights granted hereunder to Label; and (i) to otherwise administer and grant rights in and to the Published Compositions and the copyrights therein, whether such rights are now known or hereafter developed, including without limitation the exclusive right to license all uses on and in connection with the internet and mobile technologies.`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      publishing.push(new Paragraph(""));
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8.4. Label shall pay to Artist ${formState.netProceeds.percentageInWords} percent (${formState.netProceeds.percentage}%) of the Net Amounts (as defined  below) received by (or credited to) Label from your interest in the Published Compositions and resulting from all exploitations of such Published Compositions.  "Net Amounts" as used in this Agreement shall mean all monies actually received by Label worldwide or credited against advances previously made to Label as compensation for the use of any Published Composition(s) less (to the extent not already deducted) (i) all actual out of pocket costs of collection, including any amounts retained by third party sub-publishers, (ii) all fees charged by third party agents (including without limitation, the CMRRA, Harry Fox Agency) any other amounts paid by way of remuneration to arrangers, adapters or translators pursuant to local collection society rules and/or practices in respect of any of the Published Compositions; (iii) reasonable outside legal expenses and court costs as herein provided; (iv) copyright registration costs, fee paid to or charged by trustees or collection agents; and, (v) any fees paid by Label or its sub-publishers or licensees in the engagement of any independent agent who is engaged for the purposes of procuring or obtaining synchronizations, commissions or other exploitations of the Published Compositions, provided that such fees are calculated only on the income generated directly from any such synchronizations, commissions or other exploitations of the Published Composition which were directly procured by such independent agent; and (vi) all other receipted out of pocket expenses incurred by Label directly in relation to the exploitation of the Published Compositions provided however that in no event will Label deduct any of its general overhead expenses.  Notwithstanding the foregoing, for revenue collected by a society for which the so-called “publisher’s share” and “writer’s share” are paid out separately (eg. public performance revenue), as between Artist and Label, Label will be entitled to collect and retain for its own account one hundred percent (100%) of the “publisher’s share” and Artist will be entitled to collect and retain for its own account one hundred percent (100%) of the “writer’s share”.`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      publishing.push(new Paragraph(""));
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8.5. Label will account to you in respect of the Published Compositions in the same manner as it does for Masters as set out in Section 5.  Amounts payable to Artist in connection with Published Compositions will not be cross-collateralized with Artist’s recoupment account (i.e applied to the repayment of Expenses) hereunder in respect of Masters.`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
      publishing.push(new Paragraph(""));
    } else {
      publishing.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `8. PUBLISHING INTENTIONALLY DELETED`,
              bold: true,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );
    }

    let artistSignature = [];
    for (let i = 0; i < formState.artists.length; i++) {
      artistSignature = [
        ...artistSignature,
        ...[
          new Paragraph({
            children: [
              new TextRun({
                text: `Artist`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
              new TextRun({
                text: `______________________________`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 3,
              }),
              new TextRun({
                text: `Print Name: ${formState.artists[i].legalName}`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 1,
              }),
              new TextRun({
                text: `Date of Birth: ${formState.artists[
                  i
                ].dob.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })}`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 1,
              }),
            ],
            keepLines: true,
          }),
        ],
      ];
    }

    let writerSignature = [];
    for (let i = 0; i < formState.artists.length; i++) {
      writerSignature = [
        ...writerSignature,
        ...[
          new Paragraph({
            children: [
              new TextRun({
                text: `By: ______________________________`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 3,
              }),
              new TextRun({
                text: `${formState.artists[i].legalName}`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 1,
              }),
            ],
            keepLines: true,
          }),
        ],
      ];
    }

    let scheduleA = [];

    for (let i = 0; i < formState.numberOfSongs; i++) {
      // Table title row
      const masterTitleRow = new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Title of Master Recording: ${formState.songs[i].name}`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
            columnSpan: 2, // Span across two columns
          }),
        ],
      });

      // Header row
      const masterHeaderRow = new TableRow({
        height: { value: 200, rule: "auto" },
        children: [
          new TableCell({
            width: {
              size: 5505,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Name of Royalty Participant`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
          }),
          new TableCell({
            width: {
              size: 3505,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Share of Artist Royalty`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
          }),
        ],
      });

      // Participant rows
      const masterParticipantRows = formState.artists.map(
        (participant) =>
          new TableRow({
            children: [
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${participant.legalName}`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${(100.0 / formState.artists.length).toFixed(
                          1
                        )}%`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
            ],
          })
      );

      // Combine all rows
      const masterTable = new Table({
        columnWidths: [5505, 3505],
        rows: [masterTitleRow, masterHeaderRow, ...masterParticipantRows],
      });

      // Composition table
      // Table title row
      const compTitleRow = new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Title of Composition: ${formState.songs[i].name}`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
            columnSpan: 3, // Span across two columns
          }),
        ],
      });

      // Header row
      const compHeaderRow = new TableRow({
        height: { value: 200, rule: "auto" },
        children: [
          new TableCell({
            width: {
              size: 3005,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Songwriter`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
          }),
          new TableCell({
            width: {
              size: 3005,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Publisher`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
          }),
          new TableCell({
            width: {
              size: 3005,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Split %`,
                    bold: true,
                    size: 22, // Size in half-point, so 22 half-points = 12 points
                    font: {
                      name: "Helvetica Neue",
                    },
                  }),
                ],
              }),
            ],
          }),
        ],
      });

      // Participant rows
      const compParticipantRows = formState.artists.map(
        (participant) =>
          new TableRow({
            children: [
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${participant.legalName}`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text:
                          participant.publisher == "N/A"
                            ? `${participant.publisher}`
                            : `${participant.publisherName} - ${participant.ipiNumber}`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${(100.0 / formState.artists.length).toFixed(
                          1
                        )}%`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
            ],
          })
      );

      // Combine all rows
      const compTable = new Table({
        columnWidths: [3005, 3005, 3005],
        rows: [compTitleRow, compHeaderRow, ...compParticipantRows],
      });

      scheduleA.push(masterTable);
      scheduleA.push(new Paragraph(""));
      scheduleA.push(compTable);
      scheduleA.push(new Paragraph(""));
      scheduleA.push(new Paragraph(""));
    }

    let scheduleB = [];

    // Header row
    const publishingHeaderRow = new TableRow({
      height: { value: 200, rule: "auto" },
      children: [
        new TableCell({
          width: {
            size: 3005,
            type: WidthType.DXA,
          },
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: `Title`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
          ],
        }),
        new TableCell({
          width: {
            size: 3005,
            type: WidthType.DXA,
          },
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: `Writer(s)`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
          ],
        }),
        new TableCell({
          width: {
            size: 3005,
            type: WidthType.DXA,
          },
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: `Total`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
          ],
        }),
      ],
    });

    // Participant rows
    const publishingParticipantRows = [];

    for (let i = 0; i < formState.numberOfSongs; i++) {
      for (let j = 0; j < formState.numberOfArtists; j++) {
        publishingParticipantRows.push(
          new TableRow({
            children: [
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${formState.songs[i].name}`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${formState.artists[j].legalName}`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${(100.0 / formState.artists.length).toFixed(
                          1
                        )}%`,
                        bold: true,
                        size: 22, // Size in half-point, so 22 half-points = 12 points
                        font: {
                          name: "Helvetica Neue",
                        },
                      }),
                    ],
                  }),
                ],
              }),
            ],
          })
        );
      }
    }

    // Combine all rows
    const publishingTable = new Table({
      columnWidths: [3005, 3005, 3005],
      rows: [publishingHeaderRow, ...publishingParticipantRows],
    });

    if (formState.publishingIncluded) {
      scheduleB = [
        new Paragraph({
          children: [
            new TextRun({
              text: `SCHEDULE “B”`,
              bold: true,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
            new TextRun({
              text: `FORM OF ASSIGNMENT `,
              bold: true,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
              break: 2,
            }),
          ],
          alignment: "center",
          pageBreakBefore: true,
        }),
        ...formState.artists.map(
          (artist) =>
            new Paragraph({
              children: [
                new TextRun({
                  text: `${artist.legalName}`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
                new TextRun({
                  text: `${artist.address}`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
              alignment: "center",
            })
        ),
        new Paragraph(""),
        new Paragraph({
          children: [
            new TextRun({
              text: `For good and valuable consideration, receipt of which is hereby acknowledged, the undersigned, individually and on behalf of his publishing designee, heirs, executors, successors and assigns, hereby irrevocably sells, transfers and assigns to `,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
            new TextRun({
              text: `The System Music LLC`,
              bold: true,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
            new TextRun({
              text: ` throughout the universe, one hundred percent (100%) of all right, title and interest, including but not limited to copyright and the right to renew the same, and an undivided one hundred percent (100%) of the worldwide rights of administration, promotion and collection, to my share of the musical composition listed below:`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        }),
      ];

      scheduleB.push(new Paragraph(""));
      scheduleB.push(publishingTable);

      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(
        new Paragraph({
          children: [
            new TextRun({
              text: `DATE: ${formState.agreementDate.toLocaleDateString(
                "en-US",
                {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                }
              )}`,
              bold: false,
              size: 22, // Size in half-point, so 22 half-points = 12 points
              font: {
                name: "Helvetica Neue",
              },
            }),
          ],
        })
      );

      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(new Paragraph(""));
      scheduleB.push(...writerSignature);
    }

    let scheduleC = [];

    for (let i = 0; i < formState.numberOfArtists; i++) {
      if (
        new Date() <
        new Date(
          formState.artists[i].dob.getFullYear() + 18,
          formState.artists[i].dob.getMonth(),
          formState.artists[i].dob.getDate()
        )
      ) {
        scheduleC.push(
          new Paragraph({
            children: [
              new TextRun({
                text: `SCHEDULE “C”`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
            ],
            alignment: "center",
            pageBreakBefore: true,
          })
        );

        scheduleC.push(
          new Paragraph({
            children: [
              new TextRun({
                text: `The undersigned, legal guardian(s) of `,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
              new TextRun({
                text: `${formState.artists[i].legalName} p/k/a: “${formState.artists[i].stageName}”`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: ` (“Artist”), has read the foregoing agreement and as an inducement for `,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: `The System Music LLC`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: ` (“Company”) to enter into the foregoing agreement, warrants and represents to Company that: (a) Artist will fully perform all of Artist’s obligations pursuant to the foregoing agreement; (b) the undersigned consents to the execution and performance of the foregoing agreement; (c) until the foregoing agreement has been ratified by Artist after reaching the age of majority, the undersigned shall indemnify and hold Company harmless from and against any and all reasonable costs, expenses, losses, liabilities and damages (including, without limitation, reasonable court costs, counsel fees and disbursements) arising out of the failure of Artist to comply with the terms of the Agreement.`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
              }),
              new TextRun({
                text: `AGREED, ACCEPTED, & ACKNOWLEDGED:`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
              new TextRun({
                text: `____________________`,
                bold: false,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
              new TextRun({
                text: `${formState.artists[i].parentGuardianName}`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 1,
              }),
              new TextRun({
                text: `I am the legal guardian of ${formState.artists[i].legalName} p/k/a: “${formState.artists[i].stageName}”`,
                bold: true,
                size: 22, // Size in half-point, so 22 half-points = 12 points
                font: {
                  name: "Helvetica Neue",
                },
                break: 2,
              }),
            ],
          })
        );
      }
    }

    const doc = new Document({
      sections: [
        {
          headers: {
            default: header,
          },
          children: [
            // Adding one new lines (blank paragraphs)
            new Paragraph(""),
            // The next paragraph with 'Hello, World!' text
            new Paragraph({
              children: [
                new TextRun({
                  text: `Exclusive Licensing Agreement for “${formState.releaseName}”`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            // Add more content as needed
            new Paragraph(""),
            new Paragraph(""),

            new Paragraph({
              children: [
                new TextRun({
                  text: `DATE: ${formState.agreementDate.toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }
                  )}`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            ...topArtists,
            new Paragraph(""),

            new Paragraph({
              children: [
                new TextRun({
                  text: `&`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `The “LABEL”:`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `The System Music LLC`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
                new TextRun({
                  text: `3500 S DuPont Highway, Dover, DE 19901`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `The System Music LLC (“Label”) `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `on behalf of its administered channels “The System” is delighted to have this opportunity to work with `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                ...artistsPreamble,
                new TextRun({
                  text: ` collectively (“`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Artist`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”) to distribute and exploit certain sound recordings and audiovisual works owned or controlled by Artist as further detailed herein.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `The agreement is conditional upon Artist controlling all right, title and interest in and to the recordings of the musical composition (the “`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Composition`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”) embodied as audio-only or audiovisual recordings and listed in Schedule ‘A’ hereto (the “`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Master`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”) for the Territory (as defined below), including without limitation all copyrights, free and clear of any claims, encumbrances or rights of any other person.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `In consideration for the respective covenants, agreements, representations, warranties and indemnities of the parties contained herein and for other good and valuable consideration (the receipt and sufficiency of which are hereby acknowledged by each party), the parties agree as follows:`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `1. TERRITORY`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `1.1 As used herein, the “Territory” shall mean the Universe.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `2. LICENSE PERIOD`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [...licensePeriod],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3. GRANT OF RIGHTS`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [...grantOne],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.2 Label’s exclusive rights include, without limitation, the right to itself or via a third party:`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `a. the exclusive right to manufacture, distribute, license, sub-license, lease and sell in the Territory Records derived from the Masters in any and all formats;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `b. the exclusive right to advertise, promote and market such Records in the Territory;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `c. the exclusive right to publicly perform and broadcast, and to authorize others to publicly perform and broadcast, the Masters in the Territory;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `d. the exclusive right to synchronize, and to authorize others to synchronize, the Masters with motion pictures, television programs and other audiovisual works which are produced in the Territory for exploitation throughout the world (each, a “Master Use License”).  The term of any non-exclusive Master Use License may extend beyond the License Period;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `e. the exclusive right to distribute and sell Records derived from the Masters by means of digital transmission or so-called “electronic transmission”; `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `f. the exclusive right to couple, and to authorize others to couple, the Masters with masters by other artists for inclusion so-called ‘compilation’ records, including without limitation, consumer compilation Records, promotional Records, non-retail jukebox compilations, sampler-type Records and programs for us on public transportation carriers and facilities (each a “Compilation Record”); `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `g. the exclusive right to distribute and exploit the Masters on so-called streaming services and or websites such as but not limited to www.youtube.com, www.soundcloud.com, www.spotify.com, www.pandora.com in the Territory; `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `h. the exclusive right to license the Masters alone or in conjunction with other master recordings for use on podcasts; and `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `i. the exclusive right to license and/or distribute the Masters as part of an “upstream” arrangement with a third party (including, without limitation, a record label and/or distributor)  `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `For the avoidance of doubt, the Artist shall be granted the right to host the Master on the Artist’s owned social channels and across such websites which the Artist directly owns.  If and to the extent that Artist directly receives any income from the exploitation of any Records, Artist shall immediately turn over to Label all income derived therefrom for accounting and, if applicable, payment of Royalties hereunder.    Label shall have the same audit rights with respect to such income as Artist has of Label pursuant to section 5.3 below.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.3 Label shall have the right, in the Territory during the License Period and the Sell-Off Period, to use, and authorize others to use: the names, approved likenesses, approved photographs and approved biographies of Artist and each other person performing in or rendering services in connection with Masters in the form approved by the Artist, solely for the purpose of advertising, promoting and marketing the Masters and for general goodwill advertising for the benefit of Label’s music business activities provided that no such shall directly endorse the goods or services of a third party.  Artist’s approval shall only be required once per photo, image or bio to be used and shall be deemed given if no response to the contrary is provided by Artist within five (5) business days of Label’s approval request.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.4 Label shall have the right, in the Territory during the License Period and the Sell-Off Period, to use, and authorize others to use, any artwork created by or on behalf of Artist for use on the packaging of and in connection with any Records embodying one or more of the Masters.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.5 Label shall, with the prior written consent of Artist in each case, have the exclusive right, in the Territory during the License Period, to ‘re-mix’ (as such term is commonly understood in the music industry) the Masters and to combine the Masters (or any part thereof) (or any one of them) and to authorize others to do so (each such re-mixed Master a “`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Remix`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”). In the event that a Remix is created hereunder, such Remix shall be deemed to be a ‘Master’ hereunder and subject to the terms hereof.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.6 Artist agrees that Artist shall not record, re-record, use, exploit or release for commercial sale, broadcast or communication in the Territory any Master and/or any Composition (in whole or in part) that is embodied in a Master delivered under this Agreement during the License Period.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.7 Notwithstanding anything to the contrary herein, the parties acknowledge and agree that Label shall continue to have the right to distribute, and to authorize others to distribute, worldwide in all media now or hereafter known, any and all Compilation Records created hereunder prior to the expiry of the License Period and to receive revenues in respect thereof provided that Artist receives the applicable Royalty associated therewith.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.8 Label shall have the non-exclusive right (together with Artist) to create and/or commission the creation of artwork for use in connection with the Masters and Records derived therefrom. Label shall be under no obligation to make use of artwork supplied by Artist hereunder. Label shall not make use of any artwork created by Label hereunder without the prior approval of Artist, which approval shall not be unreasonably withheld and shall be conveyed to Label within five (5) business days of Label’s request therefore; failing which Artist shall be deemed to have approved of such artwork.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `3.9 Artist hereby grants Label the right, at Label’s sole discretion, to edit, change, and/or alter the Master in any manner, including, without limitation, the right to edit, change, and/or alter the title and make any edits, changes, or alterations to the Master itself. For the avoidance of doubt, Label shall be permitted, in its sole discretion, to create so-called “slowed and reverbed”,“deep”, “sped up”, and “8D” versions (as those terms are commonly understood in the music industry) of the Master for distribution hereunder.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `4. ROYALTIES`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            ...royaltiesSection,
            new Paragraph({
              children: [
                new TextRun({
                  text: `5. ACCOUNTING`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `5.1 No less frequently than within ninety (90) days following the end of each fiscal quarter period during the License Period and the Sell-Off Period, Label shall furnish Artist with a written statement in Label’s standard accounting format setting forth the computation of royalties for the applicable monthly periods. Each such statement shall be accompanied by payment of all Royalties payable, if any. All statements shall be provided in digital form via Label’s accounting system and Artist shall be provided with access thereto.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `5.2 Sales by Label’s sub-licensees, distributors and/or partners, if any, shall be deemed to take place in the calendar quarter in which Label receives (or is credited) payment therefore from such sub-licensee. Label shall use reasonable commercial efforts to obtain prompt and accurate accounting and payment from its licensees, which shall be no less frequent than twice per annum.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `5.3 Label shall keep true and correct records and books of account relating to the sale of Records, and all other exploitations of Masters hereunder and other activities relevant to the calculation of royalties payable hereunder. All Royalty statements and all other accounts rendered by Label to Artist shall be binding upon Artist and not subject to objection by Artist for any reason unless specific objection, in writing stating the basis thereof is given to Artist within eighteen (18) months following Artist’s receipt of such statement. Artist shall be foreclosed from maintaining any action, claim or proceeding against Label in any forum or tribunal unless commenced within twenty four (24) months following Artist’s receipt of such statement. Artist shall have the right to appoint a chartered or certified public accountant (or a firm of chartered or certified public accountants) to examine and make copies of Label’s books and records insofar as they pertain to this Agreement. Such chartered or certified public accountant will act only under a confidentiality agreement which provides that any information derived from such audit or examination will not be released, divulged or published to any person, firm or corporation other than Artist, Artist’s attorneys, Artist’s advisors, to a judicial or administrative body in connection with any proceeding relating to this Agreement, or by mandate of law. Such examination shall take place at Label’s offices where such books and records are normally maintained during normal business hours, on reasonable advance notice, not more than once in any calendar year and at Artist’s sole cost and expense.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6. CONTROLLED COMPOSITIONS`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.1 Artist shall grant, or shall cause Artist’s publisher to grant, to Label and Label’s designees, licensees, or affiliates an irrevocable non-exclusive license, under copyright, to reproduce each Controlled Composition on Records and to distribute those Records in the Territory (a “`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Mechanical License`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”).`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.2 All Controlled Compositions embodied in the Masters are hereby licensed to Label for the territory at a rate equal to one hundred percent (100%) of the minimum industry rate in effect on the date of delivery of the Masters, and for the U.S. at a rate equal to seventy-five percent (75%) of the minimum statutory rate in effect on the date delivery of the Masters (respectively, the “`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Rate`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”). Notwithstanding the foregoing, in no event shall Label be obligated to pay more than a maximum of five (5) times the Rate for all musical compositions (including Controlled Compositions and non-Controlled Compositions) embodied on any EP or more than a maximum of ten (10) times the Rate for all musical compositions (including Controlled Compositions and non-Controlled Compositions) embodied on any Album. If the aggregate mechanical royalty rate for any Record exceeds the maximum aggregate mechanical royalty rate provided in the preceding sentence, the aggregate mechanical royalty rate for Controlled Compositions contained on such Record shall be reduced by the amount of that excess.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.3 If a particular Composition is embodied more than once on a particular Record, whether as a re-mixed version or otherwise, Label will pay mechanical royalties as if that Composition was embodied only once on the particular Record.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.4 Artist hereby grants, or shall cause Artist’s publisher to grant, to Label and Label’s licensees the non-exclusive right (to the extent such right is controlled by Artist) during the License Period to reproduce each Controlled Composition in promotional advertisements solely for Recordings hereunder (including so-called EPKs) or for Artist’s recording and/or performance services (subject to the Artist’s approval in each case) in any and all media (including television, radio and the internet), to reproduce, distribute and perform those promotional advertisements in any manner subject to local collection society rules and regulations and provided Label and/or its designees receive no payment therefore.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.5 Subject to local collection society rules and regulations Artist grants, or shall cause Artist’s publisher to grant, to Label and Label’s licensees at no cost the non-exclusive right during the License Period to reproduce, distribute and perform each Controlled Composition or any portion thereof by means of streaming only for promotional purposes only on websites or other digital media created or maintained by Label or its licensees or affiliates throughout the Territory.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.6 Artist further grants, or shall cause Artist’s publisher to grant, to Label and/or Label’s licensees for the duration of the License Period, a worldwide, synchronization license for each Controlled Composition that is embodied in a video that is used for promotional purposes (each, a “Video”), which synchronization licenses will be issued free of charge and free of fee and royalty.  In the event Label elects to commercially exploit such Videos, Label will negotiate in good faith a synch fee with Artist, or Artist’s publisher, as the case may be.  For the avoidance of doubt, a Video shall only be considered to be commercially exploited if it is made available for direct sale by Label.  The making available of a Video for on-demand streaming on a Streaming Source or otherwise, and the earning of advertising revenue by Label from such streams shall not be considered a commercial exploitation of such Video.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `6.7 Artist represents and warrants that with respect to any and all Compositions embodied on Masters which are not Controlled Compositions, Artist has secured, or shall promptly following the execution of this Agreement, secure for benefit of the Label and Label’s licensees Mechanical Licenses and all other publishing licenses which Artist grants to Label pursuant to this Clause 6 on the same terms and conditions which apply to Controlled Compositions under this Clause 6.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `7. TRADE-MARKS`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `7.1 Artist grants to Label the exclusive right, during the License Period, to use Artist’s name and approved likeness, image and biography in connection with the sale, marketing and promotion of the Masters and Records made therefrom including on websites.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `7.2 Artist acknowledges and agrees that Label’s name and logo shall appear on the back cover of all Records made, and the metadata of all Masters exploited via “electronic transmission”, pursuant hereto and all advertising relating to the Masters and/or such Records.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            ...publishing,
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `9. REPRESENTATIONS AND WARRANTIES`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `9.1 Artist hereby represents, warrants and covenants that: `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `a. Artist has all necessary rights, power and authority to enter into this Agreement, to perform all of the obligations to be performed by Artist hereunder and to grant to Label all of the rights granted hereunder;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `b. this Agreement does not breach or conflict with any other agreement to which Artist is a party, and Artist will not enter into any agreement or obligation which conflicts herewith;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `c. Artist is not a party to any agreement pursuant to which Artist has granted to any third party any rights in or to the Masters or which otherwise restrict the rights Artist grants to Label herein;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `d. the Masters, Artist’s name and any other audio, video or other materials delivered and contributed by Artist pursuant to this Agreement are wholly original and do not violate any laws or any rights of any party, including any copyright, trade-mark, right of privacy or other proprietary right of any party;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `e. other than as specifically set out herein, Label shall not be obligated to pay royalties or any other sums to any third parties in connection with the exercise of its rights hereunder;`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `f. Artist has secured all necessary rights from all third parties including without limitation all publishing licenses from any third parties who may hold an interest in the Compositions, to allow Label the full exercise of its rights hereunder; and`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `g. all information delivered by Artist will be true, accurate and complete.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 2,
                }),
                new TextRun({
                  text: `9.2 Artist hereby indemnifies and holds harmless Label and its licensees and assigns, and its and their shareholders, officers, directors, principals, employees and agents (the “`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Indemnified Parties`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `”) from and against any and all losses, costs (including reasonable legal fees), expenses, liabilities and damages arising out of any claim in respect of any breach or alleged breach by Artist of this Agreement or any representation, warranty, covenant, or promise made hereunder as determined by a court of competent jurisdiction. Artist will reimburse the Indemnified Parties on demand for any payment made at any time after the date hereof in respect of any liability or claim in respect of which the Indemnified Parties are entitled to be indemnified. Upon the making or filing of any such claim, action or demand, Label shall be entitled to withhold from any amounts payable under this Agreement such amounts as are reasonably related to the potential liability in issue. In the event that any such claim does not result in litigation being commenced against the Indemnified Party within one (1) year from the date such claim is initially received by the Indemnified Party, then any monies withheld pursuant to the preceding sentence shall be released to Artist, provided that if any such claim is litigated after one (1) year from the date it was initially made, the Indemnified Party may thereafter withhold monies payable under this Agreement in accordance with the preceding sentence. Artist shall be notified of any such claim, action or demand and shall have the right, at its own expense, to participate in the defense hereof with counsel of its own choosing; provided, however, that the Indemnified Party’s decision in connection with the defense or settlement of any such claim, action or demand shall be final. Label will not withhold any monies pursuant to this section provided that Artist posts a surety bond from a surety which is satisfactory to Label in its sole discretion and provided that the surety bond is in a type and amount satisfactory to Label in its sole discretion.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `10. SELL OFF PERIOD`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `10.1 Upon the expiration or earlier termination of the License Period, Label shall have the non-exclusive right for a period of six (6) months to sell its inventory of physical Records on hand as of the date of the expiration or termination of the Agreement (the “Sell-Off Period”). Label shall not, in anticipation of the Sell-Off Period, manufacture quantities of physical Records in excess of the quantity it reasonably anticipates selling prior to the termination of the Agreement. All sales of Records during the Sell-Off Period shall be in accordance with the terms and conditions of this Agreement. Without limiting the foregoing, such sales shall be in Label’s normal course of business and at the same prices in effect prior to the termination of the Agreement, and Label shall continue to credit Artist’s royalty account with royalties in accordance with the terms and conditions of this Agreement. For the avoidance of doubt there shall be no such Sell Off Period in respect of digital files, save as expressly provided herein, in respect of which take down notices shall be immediately put into effect and the Label shall have no rights with respect thereto or to the monies generated therefrom.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `11. DEFINITIONS`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `For the purposes of this Agreement, the following definitions shall apply:`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `a. “Album” means a Record embodying ten (10) or more Masters and having a playing time of at least forty (40) minutes`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `b. “Controlled Composition” shall mean a musical composition or other selection embodied on the Masters, written or composed by the Artist, any producer of the Masters, or any other persons engaged by Artist in connection with the production of Masters, in whole or in part (to the extent of that part only), alone or in collaboration with others, or which is owned or controlled, in whole or in part, directly or indirectly, by the Artist or any person, firm or corporation in which the Artist has a direct or indirect interest.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `c. “EP” means a Record embodying four (4) or more, but less than ten (10), Masters and having a playing time of at least fifteen (15) minutes`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `d. “Expenses” shall mean will mean all expenses properly paid or properly incurred by Label in respect of the production, distribution or other exploitation of the Masters, of Records derived therefrom, or otherwise in connection with the terms of this Agreement.  Without limiting the generality of the foregoing, Expenses will include the following which have been incurred in accordance with the terms of this Agreement: (A) all marketing, promotion and publicity costs incurred in connection with Records and/or the Masters; (B) all costs incurred in manufacturing and distributing Records; (C) except as otherwise expressly provided to the contrary herein, all mechanical royalties, sums paid for synchronization and other licenses to use Masters, so-called “samples” and other material, “per use” or other payments made to unions or guilds, taxes and all other payments due to third parties in connection with the acquisition or exploitation or rights in the Masters; (D) all costs incurred in ‘mastering’ the Masters; (E) all artwork costs paid or incurred by Label in connection with the acquisition, creation, design and preparation of artwork; (F) all costs incurred in creating a Remix (if applicable); (G) all costs incurred in the production of any so-called “music videos” or other audio visual assets embodying the Masters; and (H) all costs incurred in the collection of Gross Revenues including without limitation reasonable outside legal fees.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `e. “Gross Revenues” shall mean all gross receipts (including advances specifically related to the Masters) actually received by Label in the Territory and specifically derived from the exploitation of Masters, including without limitation Gross Streaming Revenues and Gross UGC Revenues.  Notwithstanding anything to the contrary in this Agreement, any and all revenues earned and received by Label from YouTube & SoundCloud channels owned or administered by Label or its affiliates shall not form part of Gross Revenues and will be solely retained by Label for its own account.  `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `f. “Gross Streaming Revenues” shall mean gross receipts actually received by Label in the Territory and specifically derived from the sale and/or other exploitation of Records derived from Masters (including without limitation royalties or fees) solely via Streaming Sources. For SoundExchange or other revenue collected by a society for which the so-called “maker share” and “performer share” are paid out separately (eg. Neighbouring Rights), as between Artist and Label, Label will be entitled to collect and retain for its own account one hundred percent (100%) of the “maker’s share” and Artist will be entitled to collect and retain for its own account one hundred percent (100%) of the “performer share”.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `g. “Gross UGC Revenues” shall mean gross amounts attributable to Records derived from Masters actually received by Label in the Territory and solely derived from YouTube’s so-called ‘AudioID’ ‘ContentID’ and/or ‘VideoID’ program.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `h. “Net Proceeds” shall mean the amount, if any, by which Gross Revenues exceeds Expenses.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `i. “Record” - any form of reproduction, distribution, transmission or communication of Masters (whether or not in physical form) now or hereafter known (including reproductions or sound alone or together with visual images) which is manufactured, distributed, transmitted or communicated primarily for personal use, home use, institutional (e.g., library or school) use, jukebox use, or use in means of transportation, including any computer-assisted media (e.g., CD-ROM, DVD Audio, CD Extra, Enhanced CD) or use as a so-called “ring tone” or “ring tune”.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `j. “Streaming Sources” shall mean exploitation of Records via so-called ‘streaming services’ which provide for the transmission of Records over the internet (on a free or subscription basis) in a manner that allows continuous listening of the Record on a device capable of facilitating such listening (including without limitation a computer or mobile device) in a substantially linear form substantially simultaneously with the transmission of the Record over the internet (eg. Spotify, Google Play, Apple Music, YouTube, Pandora, Deezer or similar services).`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12. GENERAL TERMS`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.1 Entire Agreement. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `This Agreement sets out the entire agreement between the parties and supersedes and replaces all prior agreements, discussions and understandings whether written or oral.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.2 Jurisdiction. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `This Agreement is to be construed, interpreted and enforced in accordance with, and the respective rights and obligations of the parties are to United States.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.3 Assignment. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Artist shall not assign any of its rights or obligations under this Agreement without the prior written consent of Label except an assignment to a wholly-owned loan-out company and in which case such loan-out corporation shall become a party to this Agreement and Artist shall execute an inducement letter in a form satisfactory to Label.  Label may assign any or all of this Agreement or any of its rights and/or obligations hereunder to any party.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.4 Enurement. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `This Agreement shall enure to the benefit of and shall be binding upon and enforceable against the parties and their respective heirs, executors, successors and permitted assigns.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.5 Amendment. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `No amendment or waiver of any provision of this Agreement shall be binding upon either party unless consented to in writing by such part.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.6 Force Majeure. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Neither party will be responsible to the other for any failure or delay in its performance under this Agreement occasioned by any causes beyond its control including, without limitation, any acts or omissions of the other party, acts of civil or military authority, fires, epidemics, floods, earthquakes, riots, wars, international trade embargoes, insurrections or acts of God. If any such delay occurs, any applicable time period is automatically extended for a period equal to the time lost, provided that the party affected makes reasonable efforts to correct the reason for delay and gives to the other party prompt notice of the delay.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.7 Confidentiality. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `The parties hereto agree to keep the terms and conditions of this Agreement confidential except that each party may disclose this Agreement as required by any law or court order, or to its legal and financial advisors provided such advisors agree to keep all information and this Agreement confidential.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.8 Notices. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Notices shall be in writing and sent by facsimile, courier or by registered mail to the parties at their respective addresses set out herein (or as changed by notice in writing to the other party) with a copy to Label’s legal counsel, 3500 S DuPont Highway, Dover, DE 19901 If sent by facsimile, notices shall be deemed delivered on the date sent (as per confirmation of transmission notice). If sent by courier, notices shall be deemed delivered when received. If sent by registered mail, notices shall be deemed delivered on the 5th business day (excluding holidays and postal strikes) following mailing.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.9 Services Unique. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `The services rendered by Artist and the rights and privileges granted to Label hereunder are understood and agreed to be of a special, unique, unusual, extraordinary and intellectual character, which gives them a peculiar value, the loss of which cannot be adequately remedied in an action at law for damages. In the event of an actual or threatened breach of any of the provisions of this Agreement by Artist, Label shall have the right to seek a restraining order, injunction or other appropriate equitable relief to prevent such a breach or threatened breach of this Agreement.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.10 Remedies. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `In the event of a breach or alleged breach by Label or its licensees or assigns under this Agreement, Artist shall give Label written notice thereof detailing the breach or alleged breach. In the event that such has not been cured within 30 days of written notice from Artist (or where cure is not possible within 30 days, then if Label has not commenced to cure such breach or alleged breach within 30 days), Artist's remedies shall be restricted to the right to recover actual damages in an action at law. In no event will such breach or alleged breach entitle Artist to rescind this Agreement or any of the rights granted hereunder or to enjoin or to restrain the use, distribution, exhibition or exploitation of the Masters or publishing rights granted hereunder, and Artist hereby expressly waives any right to seek injunctive or equitable relief.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.11 Severance. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Each provision of this Agreement is separate from every other provision and should any provision herein be declared invalid, illegal or unenforceable, such declaration shall in no way affect the validity or enforceability of the remaining provisions herein.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.12 Counterparts. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `This Agreement may be executed in any number of counterparts and delivered by facsimile or electronic scan, each of which shall be deemed to be an original and all of which together shall constitute one and the same instrument.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `---  REMAINDER OF PAGE INTENTIONALLY BLANK  -`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
              alignment: "center",
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `12.13. Independent Legal Advice. `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Artist acknowledges that he has been represented by and has relied upon legal counsel of his own choosing in the negotiation of this Agreement and has had its contents fully explained by such counsel, or that Artist has been advised of his right to seek such advice and counsel and has knowingly waived such right, and has read this Agreement, and is fully aware of and understands all of its terms and the legal consequences thereof.`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
              pageBreakBefore: true,
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `IN WITNESS WHEREOF, this Agreement is entered into as of the date first above written, by: `,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `The System Music LLC`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `______________________________`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Authorized Signatory`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            ...artistSignature,
            new Paragraph({
              children: [
                new TextRun({
                  text: `SCHEDULE ‘A’`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `**MASTER & PUBLISHING INFO**`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
              pageBreakBefore: true,
              alignment: "center",
            }),
            new Paragraph(""),
            ...scheduleA,
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Agreed & Accepted:  `,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `The System Music LLC`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
              ],
            }),
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph({
              children: [
                new TextRun({
                  text: `______________________________`,
                  bold: true,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                }),
                new TextRun({
                  text: `Authorized Signatory`,
                  bold: false,
                  size: 22, // Size in half-point, so 22 half-points = 12 points
                  font: {
                    name: "Helvetica Neue",
                  },
                  break: 1,
                }),
              ],
            }),
            ...artistSignature,
            ...scheduleB,
            ...scheduleC,
          ],
        },
      ],
    });

    // doc.addSection({ children: [masterTable] });

    // Use Packer to create a Blob
    const blob = await Packer.toBlob(doc);

    let fileName = "";
    for (let i = 0; i < formState.artists.length; i++) {
      fileName += formState.artists[i].stageName.replace(/\./g, "") + " ";

      if (i != formState.artists.length - 1) {
        fileName += "& ";
      }
    }

    fileName += `- ${formState.releaseName.replace(
      /\./g,
      ""
    )} (Exclusive Licensing Agreement).docx`;

    // saveAs from FileSaver will download the file
    saveAs(blob, fileName);

    return blob;
  };

  const handleSubmit = async () => {
    // e.preventDefault(); // Prevent the default form submit action

    // setFormState({
    //   ...formState,
    //   titleText: `Exclusive Licensing Agreement for “${formState.releaseName}"`,
    //   dateText: `DATE: ${formState.agreementDate.toLocaleDateString("en-US", {
    //     year: "numeric",
    //     month: "2-digit",
    //     day: "2-digit",
    //   })}`,
    //   artistsText: `${formState.artists
    //     .map((artist) => {
    //       return `The “ARTIST”: ${artist.legalName} p/k/a: “${artist.stageName}”\n${artist.address}`;
    //     })
    //     .join("\n\n")}`,
    //   artistsInPreambleText: `${formState.artists
    //     .map((artist) => {
    //       return `${artist.legalName} p/k/a: “${artist.stageName}”`;
    //     })
    //     .join(" & ")}`,
    // });

    let blob1 = createDocxBlob();
  };

  if (!user) {
    return <p>Your session has expired. Please log back in.</p>;
  }

  if (user && user.isApproved == "false") {
    return (
      <p>
        Your account must be approved by a moderator before you can upload
        albums.
      </p>
    );
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="dash">
      {user && user.role != "admin" && user.role != "user" && (
        <>
          <section className="heading">
            {/*<h5>Welcome {user && user.name}</h5>*/}
            <p>Submit an Album</p>
          </section>
          <GoalForm user={user} />
        </>
      )}

      {!showPending &&
        user &&
        (user.role == "admin" || user.role == "user") && (
          <section className="content">
            <div
              style={{
                display: "flex",
                margin: "auto",
                justifyContent: "space-between",
              }}
            >
              <button
                style={{
                  padding: "10px 20px 10px 20px",
                  marginBottom: "10px",
                  // visibility: "hidden",
                  cursor: "pointer",
                  width: "220px",
                }}
                onClick={() => {
                  setShowPurchaseContracts(!showPurchaseContracts);
                }}
              >
                {showPurchaseContracts
                  ? "Show Regular Agreements"
                  : "Show Purchase Agreements"}
              </button>
              <h1>My Agreements</h1>
              {/* <button
                style={{
                  padding: "10px 20px 10px 20px",
                  marginBottom: "10px",
                  cursor: "pointer",
                  width: "220px",
                }}
                onClick={() => {
                  navigate("/draft");
                }}
              >
                Draft Agreement +
              </button> */}
              <div style={{ position: "relative", display: "inline-block" }}>
                <button
                  onClick={toggleDropdown}
                  // style={{
                  //   padding: "10px",
                  //   backgroundColor: "#007bff",
                  //   color: "white",
                  //   border: "none",
                  //   cursor: "pointer",
                  // }}
                  style={{
                    padding: "10px 20px 10px 20px",
                    marginBottom: "10px",
                    cursor: "pointer",
                    width: "220px",
                  }}
                  // onMouseEnter={(e) =>
                  //   (e.target.style.backgroundColor = "#0056b3")
                  // } // On hover, change color
                  // onMouseLeave={(e) =>
                  //   (e.target.style.backgroundColor = "#007bff")
                  // } // On leave, revert color
                >
                  Draft Agreement +
                </button>
                {isOpen && (
                  <div
                    style={{
                      position: "absolute",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                      zIndex: 1,
                    }}
                  >
                    <a
                      href="/draft"
                      style={{
                        padding: "10px 20px",
                        display: "block",
                        textDecoration: "none",
                        color: "black",
                      }}
                    >
                      Normal Agreement
                    </a>
                    <a
                      href="/draft-purchase"
                      style={{
                        padding: "10px 20px",
                        display: "block",
                        textDecoration: "none",
                        color: "black",
                      }}
                    >
                      Purchase Agreement
                    </a>
                  </div>
                )}
              </div>
            </div>
            {user.role != "admin" && user.role != "user" && (
              <h2>Your Albums</h2>
            )}
            {(user.role == "admin" || user.role == "user") &&
              showPurchaseContracts == false && (
                <div
                  style={{
                    backgroundColor: "#d9d9d9",
                    display:
                      contracts && contracts.length > 0 ? "grid" : "flex",
                    margin: "auto",
                    justifyContent: "center",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(100px, 1fr))",
                    gap: "30px",
                    padding: "50px",
                  }}
                >
                  {contracts && contracts.length && contracts.length > 0 ? (
                    contracts.map((contract, index) => (
                      <div style={{ margin: "auto" }}>
                        <FaClipboardList size={100} />
                        <br />
                        <h3>{contract.releaseName}</h3>
                        <h5
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(`/edit/${contract._id}`);
                          }}
                        >
                          Edit
                        </h5>
                        <h5
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setFormState({
                              ...contracts[index],
                              agreementDate: new Date(
                                contracts[index].agreementDate
                              ), // Convert agreementDate to Date object
                              artists: contracts[index].artists.map(
                                (artist) => ({
                                  ...artist,
                                  dob: artist.dob ? new Date(artist.dob) : null, // Convert dob to Date object, handling potential nulls
                                })
                              ),
                            });
                          }}
                        >
                          Download
                        </h5>
                        {user && user.role == "admin" && (
                          <h5
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this contract?"
                                )
                              ) {
                                // Perform the delete action here if confirmed
                                // For example, you might call a function to delete the contract from the database
                                //console.log("Contract deleted"); // Replace this with actual delete logic
                                //console.log("USER TOKEN", user.token);

                                const config = {
                                  headers: {
                                    Authorization: `Bearer ${user.token}`,
                                  },
                                };

                                // Use axios to send a delete request to contracts api
                                const response = await axios.delete(
                                  `/api/contracts/${contract._id}`,
                                  config
                                );
                                if (response.data) {
                                  console.log("Contract deleted");
                                  setContracts(
                                    contracts.filter(
                                      (c) => c._id !== contract._id
                                    )
                                  );
                                  // refresh the page
                                  window.location.reload();
                                }
                              }
                            }}
                          >
                            Delete
                          </h5>
                        )}
                      </div>
                    ))
                  ) : (
                    <div>No agreements created yet.</div>
                  )}
                </div>
              )}

            {(user.role == "admin" || user.role == "user") &&
              showPurchaseContracts == true && (
                <div
                  style={{
                    backgroundColor: "#d9d9d9",
                    display:
                      contracts && contracts.length > 0 ? "grid" : "flex",
                    margin: "auto",
                    justifyContent: "center",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(100px, 1fr))",
                    gap: "30px",
                    padding: "50px",
                  }}
                >
                  {purchaseContracts &&
                  purchaseContracts.length &&
                  purchaseContracts.length > 0 ? (
                    purchaseContracts.map((contract, index) => (
                      <div style={{ margin: "auto" }}>
                        <FaClipboardList size={100} />
                        <br />
                        <h3>{contract.songs[0].name}</h3>
                        <h5
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(`/edit-purchase/${contract._id}`);
                          }}
                        >
                          Edit
                        </h5>
                        <h5
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setPurchaseFormState({
                              ...purchaseContracts[index],
                              agreementDate: new Date(
                                purchaseContracts[index].agreementDate
                              ), // Convert agreementDate to Date object
                              artists: purchaseContracts[index].artists.map(
                                (artist) => ({
                                  ...artist,
                                  dob: artist.dob ? new Date(artist.dob) : null, // Convert dob to Date object, handling potential nulls
                                })
                              ),
                            });
                          }}
                        >
                          Download
                        </h5>
                        {user && user.role == "admin" && (
                          <h5
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this contract?"
                                )
                              ) {
                                // Perform the delete action here if confirmed
                                // For example, you might call a function to delete the contract from the database
                                //console.log("Contract deleted"); // Replace this with actual delete logic
                                //console.log("USER TOKEN", user.token);

                                const config = {
                                  headers: {
                                    Authorization: `Bearer ${user.token}`,
                                  },
                                };

                                // Use axios to send a delete request to contracts api
                                const response = await axios.delete(
                                  `/api/purchasecontracts/${contract._id}`,
                                  config
                                );
                                if (response.data) {
                                  console.log("Contract deleted");
                                  setPurchaseContracts(
                                    contracts.filter(
                                      (c) => c._id !== contract._id
                                    )
                                  );
                                  // refresh the page
                                  window.location.reload();
                                }
                              }
                            }}
                          >
                            Delete
                          </h5>
                        )}
                      </div>
                    ))
                  ) : (
                    <div>No agreements created yet.</div>
                  )}
                </div>
              )}
          </section>
        )}
    </div>
  );
}

export default Dashboard;
